// 单词库路由配置
export const MAGICCUBE_ROUTES = [
  {
    path: '/',
    name: 'index',
    component: resolve => {
      require(['../pages/common/index.vue'], resolve)
    },
    redirect: '/myMagic',
    children: [
      {
        path: 'myMagic',
        name: 'myMagic',
        component: resolve => {
          require(['../pages/myMagic/index.vue'], resolve)
        },
        redirect: '/myMagic/magicList',
        children: [
          {
            path: 'magicList',
            name: 'magicList',
            component: resolve => {
              require(['../pages/myMagic/magicList.vue'], resolve)
            },
            meta: {
              title: '魔方系统-我的魔方'
            }
          },
          {
            path: 'appList/:hid?',
            name: 'appList',
            component: resolve => {
              require(['../pages/myMagic/appList.vue'], resolve)
            },
            meta: {
              title: '魔方系统-应用列表'
            },
            props: true
          }
        ]
      },
      {
        path: 'system',
        name: 'system',
        component: resolve => {
          require(['../pages/system/index.vue'], resolve)
        },
        redirect: '/system/appsList',
        children: [
          {
            path: 'appsList',
            name: 'appsList',
            component: resolve => {
              require(['../pages/system/appsList.vue'], resolve)
            },
            meta: {
              title: '魔方系统-系统管理'
            }
          },
          {
            path: 'appEdit/:hid?',
            name: 'appEdit',
            component: resolve => {
              require(['../pages/system/appEdit.vue'], resolve)
            },
            meta: {
              title: '魔方系统-应用编辑'
            },
            props: true
          }
        ]
      }
    ]
  },
  {
    path: '/edit/:hid?',
    name: 'edit',
    component: resolve => {
      require(['../pages/myMagic/edit.vue'], resolve)
    },
    meta: {
      title: '魔方系统-内容编辑'
    },
    props: true
  },
  {
    path: '/preview/:hid?',
    name: 'preview',
    component: resolve => {
      require(['../pages/myMagic/preview.vue'], resolve)
    },
    meta: {
      title: '魔方系统-预览'
    },
    props: true
  }
]



// WEBPACK FOOTER //
// ./common/commonModule/magicCube/router/routes.js